import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/fixed-deposit-calculator',
  component: () => import('../../routes/FixedDepositCalculator.svelte'),
  card: {
    id: 'fixed-deposit-calculator',
    title: 'Fixed Deposit (FD) Calculator',
    description: 'Calculate your Fixed Deposit maturity value with compound interest. Compare quarterly, monthly, and annual compounding.',
    icon: 'account_balance',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/fixed-deposit-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Fixed Deposit (FD) Calculator – Free FD Maturity & Interest Calculator',
    description: 'Free Fixed Deposit calculator to calculate FD maturity value with compound interest. Supports quarterly, monthly, and annual compounding frequencies.',
  },
};

export default meta;
